import {
  DOWNLOAD_REQUEST,
  DOWNLOAD_SUCCEEDED,
  DOWNLOAD_FAILED,
} from "constants/actionTypes";

import axios from "axios";
import { createAction } from "redux-actions";
import { call, put, takeLatest } from "redux-saga/effects";

const API_URL = process.env.REACT_APP_API_URL;

/** fetch accounts */
export const fetchDownload = createAction(DOWNLOAD_REQUEST);
const fetchingDownloadSucceeded = createAction(DOWNLOAD_SUCCEEDED);
const fetchingDownloadFailed = createAction(DOWNLOAD_FAILED);

function* fetchDownloadSaga(action) {
  let { id, request, url, page, limit } = action.payload;

  let downloadUrl = `${API_URL}` + "/" + url;

  const fetchDownloadAPI = () => {
    return axios({
      method: "POST",
      url: downloadUrl,
      params: { page, limit },
      data: request,
    }).then((response) => response.data);
  };

  try {
    const response = yield call(fetchDownloadAPI);
    yield put(fetchingDownloadSucceeded(response));
  } catch (error) {
    yield put(fetchingDownloadFailed(error));
  }
}

export default function* downloadsSaga() {
  yield takeLatest(DOWNLOAD_REQUEST, fetchDownloadSaga);
}
